module.exports = __webpack_public_path__ + "static/media/Rainbow_Arrogance.9f98f890.gif";